import constants from 'lib/config'
import { LocalStorageKeyEnum } from 'lib/types/LocalStorageKeyEnum'
import removeLocalStorage from './removeLocalStorage'

export default function clearUsersLocalStorage() {
  removeLocalStorage(constants.authTokenName)
  removeLocalStorage(constants.refreshTokenName)
  removeLocalStorage(LocalStorageKeyEnum.UserId)
}
